const scrollToError = {
  methods: {
    scrollToError: function() {
      if(this.$mq === 'mobile') {
        this.$nextTick(() => {
          //scroll to the first error
          let elementsInErrors = document.getElementsByClassName('error');
          if (elementsInErrors && elementsInErrors.length > 0) {
              elementsInErrors[0].scrollIntoView();
          }
        });
      }
    }
  }
}

export default scrollToError;


// WEBPACK FOOTER //
// ./src/mixins/scrollToError.js